module.exports = __webpack_public_path__ + "img/scalify.10d6bc06.gif";